// extracted by mini-css-extract-plugin
module.exports = {"success-text":"SendLinkView_success-text__5hgju","success-description":"SendLinkView_success-description__P5BgZ"};